import { Navigate, useParams } from 'react-router';
import { ApplyPlanBody } from './ApplyPlanBody';
import {
  useHwcgFlag,
  useUscgFocRequirementsFlag,
} from 'utils/featureFlags';

/** Full-page Apply Plan: pick a library plan and clone it into this incident. */
export function ApplyPlanPage() {
  const { incidentId } = useParams<{ incidentId: string }>();
  const hwcg = useHwcgFlag();
  const uscgFoc = useUscgFocRequirementsFlag();
  const canApply = hwcg || uscgFoc;

  if (!incidentId) {
    return <Navigate to="/hub" replace />;
  }
  if (!canApply) {
    return <Navigate to={`/iap/${incidentId}/dashboard`} replace />;
  }

  return (
    <div className="dark tw:flex tw:h-full tw:min-h-0 tw:flex-col tw:gap-3 tw:p-4 tw:text-foreground">
      <div>
        <h1 className="tw:text-lg tw:font-semibold">Apply a plan</h1>
        <p className="tw:mt-1 tw:text-sm tw:text-muted-foreground">
          Clone a Plan Library template into this workspace.
        </p>
      </div>
      <div className="tw:min-h-0 tw:flex-1 tw:overflow-y-auto tw:rounded-md tw:border tw:border-border tw:p-3">
        <ApplyPlanBody incidentId={incidentId} />
      </div>
    </div>
  );
}
